import type { ElementType, FormElement } from '../model/form.types';
import { getElementRegistryEntry } from './element-registry';

export function generateElementId(type: ElementType): { elementId: string; shortId: string } {
  const shortId = crypto.randomUUID().slice(0, 8);
  return { elementId: `${type.toLowerCase()}-${shortId}`, shortId };
}

export function createElement(type: ElementType): FormElement {
  const { elementId, shortId } = generateElementId(type);
  const entry = getElementRegistryEntry(type);

  return {
    id: elementId,
    type,
    position: 0,
    properties: entry
      ? entry.createProperties(shortId)
      : { name: `element_${shortId}`, label: 'Elemento' },
  };
}
